import React from "react";
import Layout from "../layouts/Layout";
import Hero from "../components/home/Hero";
import Events from "../components/home/Events";
import OurCourses from "../components/home/OurCourses";
import Aboutus from "../components/home/Aboutus";
import StudentsReviews from "../components/home/StudentsReviews";
import SubscribeCard from "../components/cards/SubscribeCard";

const Home = () => {
  return (
    <Layout>
      <Hero />
      <Events />
      <OurCourses padding="px-4 sm:px-0 pt-8 md:pt-12 xl:pt-16 2xl:pt-[87px]" title="Explore Our Courses" />

      <Aboutus />
      <StudentsReviews />
      <SubscribeCard />
    </Layout>
  );
};

export default Home;
